import { WarningOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import styles from './FetchErrorSection.module.scss';

interface IProp {
  onRetry?: VoidFunction;
  retryText?: string;
}

export const FetchErrorSection = ({
  onRetry = () => window.location.reload(),
  retryText = 'Обновить страницу',
}: IProp) => (
  <div className={styles.wrapper}>
    <WarningOutlined className={styles.icon} />
    <p className={styles.annotation}>Произошла ошибка при загрузке данных</p>
    <Button
      type="primary"
      onClick={onRetry}
    >
      {retryText}
    </Button>
  </div>
);
